import React, { useState } from 'react';

import { clsx } from '@wego/alexis/helpers/clsx';

import ImageGallery from '@components/ImageGallery/ImageGallery';

import MultipleImagesIcon from '@icons/multiple_images.svg';

import styles from './RoomImageGallery.module.scss';

interface RoomImageGalleryProps {
  locale: string;
  roomImages: Array<string>;
}

const RoomImageGallery: React.FC<RoomImageGalleryProps> = ({ roomImages, locale }) => {
  const [isImageGalleryOpen, setIsImageGalleryOpen] = useState<boolean>(false);

  if (roomImages.length === 0) return null;

  return (
    <div className={clsx(styles.container)} onClick={() => setIsImageGalleryOpen(true)}>
      <div className={styles.roomImage}>
        <img src={roomImages[0]} alt='room image' />

        <button className={styles.moreImages}>
          <MultipleImagesIcon className={styles.icon} />
          {roomImages.length}
        </button>
      </div>

      <ImageGallery
        isOpen={isImageGalleryOpen}
        imageUrls={roomImages}
        startImageIndex={0}
        locale={locale}
        onClose={(event) => {
          setIsImageGalleryOpen(false);
          event.stopPropagation();
        }}
      />
    </div>
  );
};

export default RoomImageGallery;
